(function (){
  'use strict';

  angular.module('ringbaPortal').directive('refreshTable', refreshTable);

  function refreshTable () {
    return {
      require: 'stTable',
      restrict: 'A',
      link:function(scope, elem, attr, table){
        scope.$on(attr.refreshTable, function() {
          table.pipe(table.tableState());
        });
      }
    };
  }
})();
